import { FunctionComponent, useEffect, useState } from 'react'
import { useAuth } from '@/modules/context/AuthContext'
import { RequireAuth } from '@/modules/routes/requireAuth'
import { Role } from '@/types/Role'
import ParentChilds from './parentChilds/parentChilds'
import { useLocation } from 'react-router-dom'

const AccountChilds: FunctionComponent = () => {
    const { user } = useAuth()

    const paramAccount: URLSearchParams = new URLSearchParams(useLocation().search)

    const [signUp, setSignUp] = useState<boolean>(false)
    const [signUpAutolink, setSignUpAutolink] = useState<boolean>(false)

    useEffect(() => {
        if (paramAccount.get('account') === 'signup') {
            setSignUp(true)
        }
        if (paramAccount.get('account') === 'signupAutolink') {
            setSignUpAutolink(true)
        }
    }, [])

    return (
        <RequireAuth roles={[Role.parent]}>
            <>{user && user.role == Role.parent && <ParentChilds signUp={signUp} signUpAutolink={signUpAutolink} />}</>
        </RequireAuth>
    )
}

export default AccountChilds
